module.exports = __webpack_public_path__ + "img/detail-6.9df2c3d8.jpg";